import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core'
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

import { useLiterals } from '~/components/Literals'

const useStyles = makeStyles({
  tooltip: {
    borderRadius: 4,
    background: '#FFF',
    color: '#000',
    padding: 16,
    boxShadow: '15px 30px 40px 5px rgba(0, 0, 0, 0.5)',
  },
})

const handleFormatterDate = (date) => {
  return new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short' }).format(new Date(date))
}

const handleFormatterPrice = (value) => {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
}

function CustomTooltip({ active, payload, label }) {
  const { getLiteral } = useLiterals()
  const classes = useStyles()

  if (active) {
    return (
      <div className={classes.tooltip}>
        <span>{getLiteral('2574')}</span>
        <br />
        <span>{handleFormatterDate(label)}</span>
        <br />
        <span style={{ fontSize: 18, fontWeight: 600 }}>{handleFormatterPrice(payload?.[0]?.value)}</span>
      </div>
    )
  }

  return null
}

function AreaChartPrice({ onlyGraphich = false, data, color, width, height }) {
  return (
    <ResponsiveContainer width={width} height={height}>
      <AreaChart
        style={{ cursor: 'pointer' }}
        width={width}
        height={height}
        data={data}
        margin={{
          top: 0,
          left: 0,
        }}
      >
        <defs>
          <linearGradient id="color" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity={0.3}></stop>
          </linearGradient>
        </defs>
        <Area type="monotone" dataKey="value" stroke={color} fill="url(#color)" activeDot={{ r: 6 }} />

        <CartesianGrid strokeDasharray="3 3" />

        {!onlyGraphich && (
          <>
            <XAxis
              dataKey="date"
              axisLine={false}
              tickLine={false}
              tickFormatter={(str) => {
                const date = handleFormatterDate(str)
                const [day, month] = date?.split('/')

                return `${day}/${month}` || ''
              }}
            />
            <YAxis
              dataKey="value"
              axisLine={false}
              tickLine={false}
              tickFormatter={(number) => `R$${number.toFixed(2).replace('.', ',')}`}
            />
            <Tooltip content={<CustomTooltip />} />
          </>
        )}
      </AreaChart>
    </ResponsiveContainer>
  )
}

export default memo(AreaChartPrice)
